import {Directive, HostBinding, HostListener} from '@angular/core';
import {MenuController} from '@ionic/angular';

@Directive({
  selector: 'ion-button[appMenuTrigger]'
})
export class MenuTriggerDirective {
  @HostBinding('attr.id') readonly id = 'menuButton';

  constructor(private menuController: MenuController) {}

  @HostListener('click', ['$event'])
  openMenu(event: Event): void {
    const trigger = event.currentTarget as HTMLElement | null;
    const nativeButton = trigger?.shadowRoot?.activeElement as HTMLElement | null;

    nativeButton?.blur();
    trigger?.blur();

    void this.menuController.open('main-menu');
  }
}
